import React, { useCallback } from 'react';
import Search from '../components/search/Search';
import PageTemplate from '../components/layout/PageTemplate';
import { useEquipItem } from '../hooks/useEquipItem';
import './Encyclopedia.css';

const TXT_ENCYCLOPEDIA = { fr: 'Encyclopédie', en: 'Encyclopedia', de: 'Enzyklopädie', es: 'Enciclopedia', pt: 'Enciclopédia' };

const Encyclopedia = ({ lang = 'fr' }) => {
    const { handleEquip } = useEquipItem(lang);

    const handleSelectItem = useCallback((selectedItem) => {
        handleEquip(selectedItem);
    }, [handleEquip]);

    return (
        <PageTemplate
            header={<h1 className="page-template-title">{TXT_ENCYCLOPEDIA[lang] || TXT_ENCYCLOPEDIA.en}</h1>}
        >
            <div className="encyclopedia-container column">
                <Search
                    lang={lang}
                    initialSearchMode={{ searchItems: true, searchSets: true }}
                    onSelectItem={handleSelectItem}
                    enableStatsQuickPanel={true}
                    autoFocus
                />
            </div>
        </PageTemplate>
    );
};

export default Encyclopedia; 